import React from 'react';

// Unified Alvo Logo Component - matches the favicon/PWA icon
// This ensures visual consistency across the entire system
export const AlvoLogo = ({ size = 40, withGlow = false, className = '' }) => {
  const viewBox = "0 0 512 512";
  
  return (
    <div 
      className={`relative flex-shrink-0 ${className}`}
      style={{ width: size, height: size }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox={viewBox}
        style={{ borderRadius: size * 0.2, display: 'block' }}
      >
        <defs>
          <linearGradient id={`bgGrad-${size}`} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{ stopColor: '#1a1a1a' }} />
            <stop offset="100%" style={{ stopColor: '#2a2a2a' }} />
          </linearGradient>
          <linearGradient id={`iconGrad-${size}`} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{ stopColor: '#22C55E' }} />
            <stop offset="100%" style={{ stopColor: '#10B981' }} />
          </linearGradient>
        </defs>
        {/* Background with slight border effect */}
        <rect width="512" height="512" rx="100" fill={`url(#bgGrad-${size})`} stroke="#333" strokeWidth="8" />
        {/* Crosshair icon */}
        <g transform="translate(256, 256)">
          {/* Outer circle */}
          <circle cx="0" cy="0" r="140" fill="none" stroke={`url(#iconGrad-${size})`} strokeWidth="24" />
          {/* Crosshair lines */}
          <line x1="0" y1="-180" x2="0" y2="-100" stroke={`url(#iconGrad-${size})`} strokeWidth="24" strokeLinecap="round" />
          <line x1="0" y1="100" x2="0" y2="180" stroke={`url(#iconGrad-${size})`} strokeWidth="24" strokeLinecap="round" />
          <line x1="-180" y1="0" x2="-100" y2="0" stroke={`url(#iconGrad-${size})`} strokeWidth="24" strokeLinecap="round" />
          <line x1="100" y1="0" x2="180" y2="0" stroke={`url(#iconGrad-${size})`} strokeWidth="24" strokeLinecap="round" />
          {/* Center dot */}
          <circle cx="0" cy="0" r="20" fill={`url(#iconGrad-${size})`} />
        </g>
      </svg>
      
      {/* Optional glow effect */}
      {withGlow && (
        <div 
          className="absolute inset-0 rounded-xl animate-pulse-soft pointer-events-none"
          style={{ 
            boxShadow: '0 0 40px 8px rgba(168, 201, 74, 0.2), 0 0 80px 15px rgba(90, 172, 184, 0.15)'
          }}
        />
      )}
    </div>
  );
};

// Simplified version using just gradient background + lucide icon
// For smaller sizes where the SVG detail might be lost
export const AlvoLogoSimple = ({ size = 40, className = '' }) => {
  return (
    <div 
      className={`flex items-center justify-center rounded-xl flex-shrink-0 ${className}`}
      style={{ 
        width: size, 
        height: size,
        background: 'linear-gradient(135deg, #22C55E, #10B981)',
        boxShadow: '0 4px 20px -5px rgba(168, 201, 74, 0.4), 0 2px 10px -3px rgba(90, 172, 184, 0.3)'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size * 0.55}
        height={size * 0.55}
        viewBox="0 0 24 24"
        fill="none"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="22" y1="12" x2="18" y2="12" />
        <line x1="6" y1="12" x2="2" y2="12" />
        <line x1="12" y1="6" x2="12" y2="2" />
        <line x1="12" y1="22" x2="12" y2="18" />
      </svg>
    </div>
  );
};

export default AlvoLogo;
